module.exports = __webpack_public_path__ + "img/white.b51db62.svg";